import { helper } from '@ember/component/helper';

const fieldsToDisableIfSourceNotHero = [
  'core:emailAddress',
  'core:firstName',
  'core:lastName',
  'core:staffGender',
];

export default helper(function isFieldDisabled([
  readonly,
  entity,
  isEditStaff,
  key,
]) {
  if (readonly) {
    return true;
  }

  // If we aren't editing a staff member don't disable the field
  if (!isEditStaff) {
    return false;
  }

  // If field is empty don't disable the field
  let field = entity.fields.get(key);
  if (!field || !field.get('value')) {
    return false;
  }

  // Check if this staff member originates from Hero and if the key is in the editable fields array
  if (!entity.isHeroSource && fieldsToDisableIfSourceNotHero.includes(key)) {
    return true;
  }

  return false;
});
